
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnowShowersNight as ObiHeavySnowShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow-showers-night.js';
 
 
 

 
 export const ObiHeavySnowShowersNight = createComponent({
   react: React,
   tagName: 'obi-heavy-snow-showers-night',
   elementClass: ObiHeavySnowShowersNightElement,
   events: {
     
   }
  });
 
 